module.exports = __webpack_public_path__ + "img/BAU Seniors_29.2595dba4.jpg";